import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, font } = baseVariables;

export const StyledNavigationMenuWrapper = styled.div`
  position: relative;
  z-index: 11;
`;

export const StyledNavigationMenu = styled.div`
  position: relative;
  display: block;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background-color: ${color.base20};
  z-index: 2;
`;

export const StyledActiveMenuContainer = styled.div<{ selectedMenuIndex: boolean; isMenuOpen: boolean }>`
  position: relative;
  min-height: ${toRem(56)};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${toRem(16)};
  border-top: ${toRem(1)} solid ${({ selectedMenuIndex }) => (selectedMenuIndex ? color.neutral20 : color.neutral30)};
  border-bottom: ${toRem(1)} solid ${({ selectedMenuIndex }) => (selectedMenuIndex ? color.neutral20 : color.neutral30)};
  cursor: ${({ isMenuOpen }) => (isMenuOpen ? 'default' : 'pointer')};
`;

export const StyledActiveMenuLabel = styled.span`
  font-size: ${toRem(18)};
  font-weight: ${font.fontWeightMedium};
  color: ${color.base10};
  line-height: 1;
`;

export const StyledDropdownIcon = styled.span`
  position: absolute;
  right: ${toRem(16)};
  top: 50%;
  transform: translateY(-50%);
  font-size: ${toRem(24)};
  pointer-events: none;
  cursor: inherit;
`;

export const StyledCloseButton = styled.button`
  position: absolute;
  right: ${toRem(16)};
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  font-size: ${toRem(24)};
`;

export const StyledMainMenu = styled.nav`
  display: none;
  height: calc(100vh - ${toRem(56)});
  background: ${color.base20};
  position: relative;
  overflow: auto;
  &.open {
    display: block;
  }
`;

export const StyledMainMenuItems = styled.ul`
  margin: 0;
  padding: ${toRem(24)};
  list-style: none;
`;

export const StyledMainMenuItem = styled.li`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${toRem(10)} 0;
  border-bottom: ${toRem(1)} solid ${color.neutral30};
  color: inherit;
  list-style-type: none;
  min-height: ${toRem(48)};
  a,
  button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 0;
    border-bottom: 0;
    font-size: ${toRem(16)};
    font-weight: ${font.fontWeightRegular};
    color: ${color.base10};
    background: transparent;
    .sub-menu-toggler {
      position: absolute;
      right: ${toRem(24)};
      width: ${toRem(24)};
      height: ${toRem(24)};
      font-size: ${toRem(24)};
    }
    &:hover {
      font-weight: ${font.fontWeightRegular};
    }
  }
`;

export const StyledSubMenuWithBackCta = styled.div`
  display: none;
  background: ${color.base20};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  max-height: calc(100% - ${toRem(120)});
  overflow-y: auto;
  &.open {
    display: block;
  }
`;

export const StyledBackCta = styled.button`
  width: ${toRem(24)};
  height: ${toRem(24)};
  position: absolute;
  z-index: 1;
  left: ${toRem(16)};
  top: 50%;
  transform: translateY(-50%);
  display: block;
  padding: 0;
  background: transparent;
  border: 0;
  cursor: pointer;

  .icon-back-arrow-cropped,
  .icon-forward-arrow-cropped {
    font-size: ${toRem(18)};
    color: ${color.base10};
  }
`;
